export class AcceptMessagingGuidelinesError extends Error {
  readonly status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = "AcceptMessagingGuidelinesError"
    this.status = status
  }
}

export async function acceptMessagingGuidelines(): Promise<{ acceptedAt: string }> {
  const res = await fetch("/api/chat/accept-guidelines", { method: "POST" })
  if (!res.ok) {
    let detail = `Accept guidelines failed (${res.status})`
    try {
      const payload = (await res.json()) as { error?: string }
      if (payload?.error) detail = payload.error
    } catch {}
    throw new AcceptMessagingGuidelinesError(detail, res.status)
  }
  const json = (await res.json()) as { acceptedAt?: string }
  return { acceptedAt: json.acceptedAt ?? new Date().toISOString() }
}
